import { render, staticRenderFns } from "./StudentRelationsArAccountsList.vue?vue&type=template&id=f8007912&"
import script from "./StudentRelationsArAccountsList.vue?vue&type=script&lang=js&"
export * from "./StudentRelationsArAccountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports